import { combineReducers } from "@reduxjs/toolkit";
import { ServiceAPI } from "./features/Service/serviceSlice";
import { JobAPI, JobReducer } from "./features/Job/jobSlice";
import dateRangeReducer from "../reducer/features/Date/dateRangeSlice";
const rootReducer = combineReducers({
  [ServiceAPI.reducerPath]: ServiceAPI.reducer,
  [JobAPI.reducerPath]: JobAPI.reducer,
  JobReducer,
  dateRange: dateRangeReducer,
});
export type AppState = ReturnType<typeof rootReducer>;
export default rootReducer;
